import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddcampaignComponent } from './addcampaign/addcampaign.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {​​​​​​​​ MatDatepickerModule }​​​​​​​​ from'@angular/material/datepicker';
import {​​​​​​​​ MatInputModule }​​​​​​​​ from'@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
  declarations: [AddcampaignComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    NgxSpinnerModule
  ]
})
export class AddcampaignModule { }
